import { isValidJSON } from "../app/utils/utils";

Monet.Configurations = {

    ajaxStart: function () {
        return $(document).ajaxStart(function () {
            $('#loading_img').show();
        });
    },

    ajaxStop: function () {
        return $(document).ajaxStop(function () {
            $('#loading_img').hide();
            Monet.I18n.checkResources();

        });
    },

    ajaxError: function () {

        $(document).ajaxError(function (e, jqxhr, settings, exception) {
            Monet.Configurations.errorNotification(e, jqxhr, settings, exception);
        });

    },
    ajaxGlobalSetup: function () {

        $.ajaxSetup({
            cache: false,
            global: true,
            beforeSend: function (xhr) {
                xhr.url = encodeURI(xhr.url);
                xhr.setRequestHeader("Greenmile-Module", "LIVE");
                xhr.setRequestHeader("Greenmile-Version", App.Version.GMLVersionNumber);
                xhr.setRequestHeader("Greenmile-Build", App.Version.GMLBuildNumber);
            }
        });
    },

    errorNotification: function (e, jqxhr, settings, exception) {

      var showGenericError = true;
      let messageObj={};
      let finalMessages = Monet.I18n.getResourcesByKey('Greenmile.MessageErroServer.unknownError');
      const jqxhrResponseText = jqxhr.responseText;
      
      if (jqxhrResponseText && typeof (jqxhrResponseText) === 'string' && !jqxhrResponseText.includes('<html>')) {

          messageObj = isValidJSON(jqxhrResponseText);
          finalMessages = messageObj ? Monet.Form.Messages.getErrorMessageToBeDisplayed(messageObj.errorMessages) : jqxhrResponseText;
          const finalMessage = Array.isArray(finalMessages) ? finalMessages[0] : finalMessages;
          this._showAlertToUser(jqxhr.status, null, finalMessage);
      } else if (jqxhrResponseText.indexOf("HTTP Status 500") !== -1) {

          this._showAlertToUser(jqxhr.status, null, 'Greenmile.MessageErroServer.internalError');
      } else if (jqxhr.status === 0) {
        const browserIsOnline = navigator?.onLine;

        if (!browserIsOnline) {
            this.showBrowserOfflineAlert();
        } else {
            this._showAlertToUser(
                jqxhr.status, 
                null,  
                'Greenmile.MessageErroServer.serverunavailable'
            );
        }

      } else if (jqxhr.status === 500) {

          try {

              if(finalMessages) {
                  showGenericError = false;
              }

              this._showAlertToUser(jqxhr.status, exception, 'Greenmile.MessageErroServer.internalError');

          } catch (ex) {

              const stripHTML = function(s) {
                  let lastString;

                  do {
                      s = $('<div>').html(lastString = s).text();
                  } while(lastString !== s);

                  return s;
              };

              const serverMessage = stripHTML(jqxhr.responseText);

              this._showAlertToUser(jqxhr.status, serverMessage);
          }

      } else if (jqxhr.status === 503) {

          this._showAlertToUser(jqxhr.status, null, 'Grenmile.MessageErroServer.serviceUnable');

      } else if (jqxhr.status === 400 || jqxhr.status === 415 || exception === 'parsererror') {

          this._showAlertToUser(jqxhr.status, null, 'Greenmile.MessageErroServer.errorAnalyzeJson');

      } else if (jqxhr.status === 403) {

          Monet.Authentication.redirectLogin(jqxhr);

      } else if (jqxhr.status === 401) {

          showGenericError = false;
          window.location = '#/AccessDenied/' + jqxhr.status;

      } else if (jqxhr.status === 404) {
          this._showAlertToUser(jqxhr.status, null, 'Greenmile.MessageErroServer.requestNotFound');

      } else if (jqxhr.status === 409 || jqxhr.status === 412) {

          showGenericError = false;

      } else if (jqxhr.status === 422) {

          if (messageObj.errorMessages) {

              if (!Monet.Form.Messages.getErrorMessageToBeDisplayed(messageObj.errorMessages)) {
                  this._showAlertToUser(jqxhr.status, exception);
              } else {
                  showGenericError = false;
              }

          } else {
              showGenericError = false;
          }

      } else if (exception === 'timeout') {
          this._showAlertToUser(jqxhr.status, exception, 'Greenmile.MessageErroServer.timeout');

      } else {
          this._showAlertToUser(jqxhr.status, exception, 'Greenmile.MessageErroServer.unknownError');
      }

        return showGenericError;
    },

    _showAlertToUser: (code, exceptionType, messageResourceKey) => {
        const message = messageResourceKey ? Monet.I18n.getResourcesByKey(messageResourceKey) : '';
        const exception = exceptionType ? exceptionType : '';
        const serverErrorLabel = Monet.I18n.getResourcesByKey('Greenmile.MessageErroServer.serverErrorLabel');
        const errorMessage = `${serverErrorLabel}: ${code}\r${message}\r${exception}`;
        new Greenmile.Components.AlertModal(errorMessage)
            .show();
    },

    showBrowserOfflineAlert: () => {
        const message =  'Greenmile.MessageError.BrowserOffline';
        const title = 'Greenmile.AlertError.BrowserOffline.Title';

        new Greenmile.Components.AlertModal(message, title).show();
    }
};
